"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "imageDataToCanvas", {
    enumerable: true,
    get: function() {
        return imageDataToCanvas;
    }
});
function imageDataToCanvas(imageData) {
    // imageData = {data: Uint8ClampedArray, width, height, colorSpace: 'srgb'}
    if (!imageData || !imageData.width || !imageData.height || !imageData.data) {
        throw new Error("Invalid imageData object. It should have width, height, and data properties.");
    }
    // Create a canvas element and set its dimensions
    const canvas = document.createElement("canvas");
    canvas.width = imageData.width;
    canvas.height = imageData.height;
    // Get a 2D rendering context
    const context = canvas.getContext("2d");
    // Draw the image data onto the canvas
    context.putImageData(imageData, 0, 0);
    return canvas;
}
